
import Model from "../../services/entities/ads/ads";
import Injection = EECore.Injection;

@Injection.injectableClass("AdsSlide")
export default class AdsSlide implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("AdsSlide", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  model: Model;

  constructor(templateFactory: EECore.UI.TemplateFactory) {
    this.templateFactory = templateFactory;
  }

  load(): Element {
    if (this.model === null) throw new Error("web component model is required");
    return this.templateFactory.getTemplate("AdsSlide", this.model);
  }
}